import * as t from 'io-ts';

export const UnreadResponseC = t.type({ unread: t.number });

export type UnreadResponse = t.TypeOf<typeof UnreadResponseC>;
